import React from 'react';
import { Box, Typography, Container, Button, Alert, CssBaseline } from '@mui/material';
import { styled } from '@mui/system';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from 'react-router-dom';
import Mina from '../../assets/images/logo.png';

const MainContainer = styled(Box)({
  minHeight: '100vh',
  backgroundColor: '#FFFFFF',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: 'Manrope, sans-serif',
  padding: '20px',
  '@media (min-width: 769px)': {
    alignItems: 'flex-start',
    paddingTop: '120px',
  },
  '@media (max-width: 768px)': {
    alignItems: 'flex-start',
    paddingTop: '120px',
    padding: '120px 20px 40px',
  },
});

const StyledContainer = styled(Container)({
  maxWidth: '700px !important',
  width: '700px',
  fontFamily: 'Manrope, sans-serif',
  textAlign: 'center',
});

const StyledButton = styled(Button)({
  width: '100%',
  marginTop: '1rem',
  marginBottom: '1rem',
  backgroundColor: '#9333EA',
  color: 'white',
  borderRadius: '4px !important',
  border: '1px solid #9333EA',
  padding: '12px 14px',
  fontWeight: 600,
  fontSize: '15px',
  textTransform: 'none',
  letterSpacing: 0,
  fontFamily: 'Manrope, sans-serif',
  minHeight: '48px',
  boxShadow: 'none !important',
  '&:hover': {
    backgroundColor: '#7928CA',
    border: '1px solid #7928CA',
  },
});

const PaymentCanceled = () => {
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate('/');
  };

  return (
    <Box>
      <CssBaseline />
      
      {/* Fixed Logo Header */}
      <Box className="logo-container-box" sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        backgroundColor: 'white',
        padding: '16px 24px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.05)',
        zIndex: 1000,
        height: '70px',
        display: 'flex',
        alignItems: 'center'
      }}>
        <img src={Mina} alt="Mina" style={{ height: '40px' }} />
      </Box>

      <MainContainer>
        <StyledContainer>
          {/* Cancel Icon */}
          <CancelIcon 
            sx={{ 
              fontSize: '80px', 
              color: '#EF4444', 
              marginBottom: '24px' 
            }} 
          />

          {/* Main Heading */}
          <Typography
            variant="h4"
            sx={{
              fontSize: '1.8rem',
              fontWeight: 700,
              color: '#111827',
              textAlign: 'center',
              marginBottom: '16px',
              fontFamily: 'Manrope, sans-serif',
            }}
          >
            Payment Canceled
          </Typography>

          {/* Cancel Message */}
          <Alert 
            severity="error"
            sx={{ 
              width: '100%', 
              marginBottom: 3,
              borderRadius: '4px',
              backgroundColor: '#FEF2F2',
              border: '1px solid #EF4444',
              '& .MuiAlert-icon': {
                color: '#EF4444'
              },
              '& .MuiAlert-message': {
                fontFamily: 'Manrope, sans-serif',
                fontSize: '14px',
                color: '#DC2626'
              }
            }}
          >
            Your payment has been canceled. No charges were made to your account.
          </Alert>

          {/* Subtitle */}
          <Typography
            sx={{
              color: '#64748b',
              fontSize: '1rem',
              textAlign: 'center',
              marginBottom: '32px',
              fontFamily: 'Manrope, sans-serif',
            }}
          >
            Don't worry, you can try again anytime. Your JLPT preparation journey continues!
          </Typography>

          {/* Back to Dashboard Button */}
          <StyledButton
            onClick={handleBackToDashboard}
            variant="contained"
          >
            Back to Dashboard
          </StyledButton>
        </StyledContainer>
      </MainContainer>
    </Box>
  );
};

export default PaymentCanceled;